import React, { useEffect } from 'react';
import { useTheme } from '../../assets/contexts/ThemeContext';
import CenterImageDynamic from './banners/CenterImageDynamic';
import BannerSimple from './banners/BannerSimple';
import BannerCard from './banners/BannerCard';
import BannerIcon from './banners/BannerIcon';
import BannerFullscreen from './banners/BannerFullscreen';
import BannerMinimal from './banners/BannerMinimal';
import BannerGlass from './banners/BannerGlass';

/**
 * 배너 컨테이너 컴포넌트
 * 원본: banner-container-only fragment
 *
 * 테마 설정에 따라 배너 유형을 동적으로 렌더링합니다.
 *
 * @param {string} title - 페이지 타이틀 (기본값: '페이지')
 * @param {Array} breadcrumbPath - breadcrumb 경로 배열 (기본값: null)
 * @param {string} bannerType - 배너 유형 (테마 설정에서 가져옴)
 * @param {object} bannerProps - 배너별 추가 props
 */
const BannerContainer = ({
  title = '페이지',
  breadcrumbPath = null,
  bannerType,
  ...bannerProps
}) => {
  const themeContext = useTheme();
  const themeConfig = themeContext?.themeConfig || {};

  // 테마 설정에서 배너 타입 가져오기 (없으면 기본값 사용)
  const finalBannerType = bannerType || themeConfig.bannerType || 'center-image-dynamic';

  // BannerData를 전역으로 설정 (원본과 동일하게)
  useEffect(() => {
    window.BannerData = {
      title: title || '페이지',
      breadcrumbPath: breadcrumbPath || null,
      leftImg: '/assets/images/page/left_slide.png',
      rightImg: '/assets/images/page/right_slide.png'
    };
  }, [title, breadcrumbPath]);

  // 배너 유형에 따라 컴포넌트 렌더링
  const renderBanner = () => {
    const commonProps = {
      title: title || '페이지',
      breadcrumbPath: breadcrumbPath || null,
      ...bannerProps
    };

    switch (finalBannerType) {
      case 'center-image-dynamic':
        return <CenterImageDynamic {...commonProps} />;
      case 'banner-simple':
        return <BannerSimple {...commonProps} />;
      case 'banner-card':
        return <BannerCard {...commonProps} />;
      case 'banner-icon':
        return <BannerIcon {...commonProps} />;
      case 'banner-fullscreen':
        return <BannerFullscreen {...commonProps} />;
      case 'banner-minimal':
        return <BannerMinimal {...commonProps} />;
      case 'banner-glass':
        return <BannerGlass {...commonProps} />;
      default:
        return <CenterImageDynamic {...commonProps} />;
    }
  };

  return (
    <div id="banner-container">
      {renderBanner()}
    </div>
  );
};

export default BannerContainer;

